import {connect} from 'react-redux';
import * as chapterPartActions from '../../store/actions/chapterPartActions';
import EditChapterPart from '../../components/EditChapterPart/EditChapterPart';
import * as VideoActions from '../../store/actions/videoActions';


const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.chapterPart,
    ...state.video
});

const mapDispatchToProps = (dispatch) => ({
    loadBlank: () => {
      dispatch(chapterPartActions.loadBlanks());
    },
    getChapterPart: (id, token) => {
        dispatch(chapterPartActions.getChapterPartById(id, token));
        dispatch(VideoActions.getVideoDiscussion(id, token));
    },
    setDefaultUploadProgress: () => {
        dispatch(VideoActions.setDefaultUploadProgress())
    },
    uploadImage: (data, chapterPartId, token) => {
        dispatch(chapterPartActions.uploadChapterPartImage(data, chapterPartId, token));
    },
    uploadBannerImage: (data, chapterPartId, token) => {
        dispatch(chapterPartActions.uploadChapterPartBanner(data, chapterPartId, token));
    },
    addVideoQuestion: (question, chapterPartId, token) => {
        dispatch(chapterPartActions.addVideoQuestion(question, chapterPartId, token));
    },
    updateVideoQuestion: (question, token) => {
        dispatch(chapterPartActions.editVideoQuestion(question, token));
    },
    addQuizQuestion: (question, files, chapterPartId, token) => {
        dispatch(chapterPartActions.addQuizQuestion(question, files, chapterPartId, token));
    },
    deleteQuestionFile: (id, token) => {
        dispatch(chapterPartActions.deleteQuestionFile(id, token));
    },
    deleteQuizQuestion: (id, token) => {
        dispatch(chapterPartActions.deleteQuizQuestion(id, token));
    },

    deleteVideoQuestion: (id, token) => {
        dispatch(chapterPartActions.deleteVideoQuestion(id, token));
    },
    postDiscussion: (comment, user, token) => {
        dispatch(VideoActions.postDiscussion(comment, user, token));
    },
    postComment: (comment, user, token) => {
        dispatch(VideoActions.postComment(comment, user, token));
    },
    postLike: (like, token) => {
        dispatch(VideoActions.postLike(like, token))
    },
    deleteLike: (like, token) => {
        dispatch(VideoActions.deleteLike(like, token));
    },
    deleteDiscussion: (id, token) => {
        dispatch(VideoActions.deleteDiscussion(id, token));
    },
    deleteComment: (id, token) => {
        dispatch(VideoActions.deleteComment(id, token));
    },
    deleteAllDiscussions: (chapterVideoId, token) => {
        dispatch(VideoActions.deleteAllDiscussions(chapterVideoId, token));
    },
    updateQuestionNumbers: (questions, token) => {
        dispatch(VideoActions.updateQuestionNumbers(questions, token));
    }
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EditChapterPart);


// WEBPACK FOOTER //
// ./src/containers/EditChapterPart/EditChapterPartContainer.js